import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetSeedTicketTypeList = (seriesIdx) => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        seriesIdx && fetchRequest("GET", `/admin/series/${seriesIdx}/seed-ticket-type/list`)
    }, [seriesIdx])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "series_idx") setAlert("대회 시리즈 idx를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("대회 시리즈 데이터가 존재하지 않습니다.")
                break
        }
    })

    return [fetchResult]
}

export default useGetSeedTicketTypeList